/* unplugin-vue-components disabled */import { render } from "./ThemeControl.vue?vue&type=template&id=248f486b&scoped=true"
import script from "./ThemeControl.vue?vue&type=script&lang=js"
export * from "./ThemeControl.vue?vue&type=script&lang=js"

import "./ThemeControl.vue?vue&type=style&index=0&id=248f486b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-248f486b"]])

export default __exports__